"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _core = require("@material-ui/core");

var _CustomValidators = _interopRequireDefault(require("../validation/CustomValidators"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormItemValidations = function FormItemValidations(_ref) {
  var _properties$validatio;

  var properties = _ref.properties,
      handleItemValidation = _ref.handleItemValidation;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCustomValidation = _useState2[0],
      setIsCustomValidation = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsCustomValidation(properties.validations.customValidation !== "" ? true : false);
  }, [properties]);
  var isInput = (0, _react.useMemo)(function () {
    return properties.type === "input" || properties.type === "textarea";
  }, [properties.type]);
  return /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Determina si el campo es no requerido",
    "aria-label": "allowNull",
    placement: "left-start"
  }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "allowNull",
      color: "primary",
      checked: properties.validations.allowNull,
      onChange: function onChange(e, data) {
        handleItemValidation(properties, "allowNull", data);
      }
    }),
    label: "Permite Nulo"
  }))), isInput && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "customRequiredMessage",
    label: "Mensaje de validaci\xF3n",
    value: properties.validations.customRequiredMessage,
    onChange: function onChange(e) {
      handleItemValidation(properties, "customRequiredMessage", e.target.value);
    }
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, properties.customValidationActive ? /*#__PURE__*/React.createElement(_core.TextField, {
    name: "customValidation",
    label: "Validaci\xF3n personalizada",
    value: properties.validations.customValidation,
    onChange: function onChange(e) {
      handleItemValidation(properties, "customValidation", e.target.value);
    }
  }) : /*#__PURE__*/React.createElement(_core.FormControl, null, /*#__PURE__*/React.createElement(_core.InputLabel, null, "Validaci\xF3n personalizada"), /*#__PURE__*/React.createElement(_core.Select, {
    name: "customValidation",
    value: (_properties$validatio = properties.validations) === null || _properties$validatio === void 0 ? void 0 : _properties$validatio.customValidation,
    onChange: function onChange(e) {
      handleItemValidation(properties, "customValidation", e.target.value);
      setIsCustomValidation(true);
    }
  }, _CustomValidators.default.map(function (t) {
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      key: t.key,
      value: t.value
    }, t.text);
  })))), isCustomValidation && /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Mensaje de validaci\xF3n personalizado",
    "aria-label": "customValidation",
    placement: "left-start"
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "customValidationMessage",
    label: "Mensaje de v. personalizado",
    value: properties.validations.customValidationMessage,
    onChange: function onChange(e) {
      handleItemValidation(properties, "customValidationMessage", e.target.value);
    }
  })))));
};

var _default = FormItemValidations;
exports.default = _default;